import { ProviderModule } from 'src/app/provider/provider.module';
import { OrgModule } from 'src/app/org/org.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { ContractWithProviderSelectorComponent } from './selector.component';
import { ContractWithProviderCreateDialogComponent } from './create-dialog/create-dialog.component';

@NgModule({
  declarations: [ContractWithProviderSelectorComponent, ContractWithProviderCreateDialogComponent],
  imports: [
    CommonModule,
    ProviderModule,
    OrgModule,
    MatIconModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MomentDateModule
  ],
  exports: [ContractWithProviderSelectorComponent]
})
export class ContractWithProviderSelectorModule {}
